import React from "react";
import { Result, Spin } from "antd";

import { API } from "utils/api";
import { Get } from "utils/request";
import {
  clearLoginState,
  getSsoToken,
  isSsoConfigured,
  pickTokenFromUrl,
  redirectToSsoLogin,
  setAdminInfo,
  setSsoToken
} from "utils/sso";

/**
 * 管理端路由守卫（统一认证中心 SSO）。
 * 只包裹管理端路由（routerList 里 admin: true 的那些）；
 * 评分端 `/mark/:id`、`/score/:id` 是外部评分人扫码进入的，保持免登录，不能包。
 */
let verifiedInThisPageLoad = false;

class RequireAuth extends React.Component {
  state = {
    status: verifiedInThisPageLoad ? "ready" : "checking",
    message: ""
  };

  componentDidMount() {
    if (this.state.status === "ready") return;
    this.verify();
  }

  verify = () => {
    if (!isSsoConfigured()) {
      this.setState({
        status: "error",
        message: "未配置认证中心地址（REACT_APP_SSO_URL），请检查 .env 配置"
      });
      return;
    }

    // 认证中心回跳时地址栏带 ssoToken，先保存再从地址栏抹掉
    const incomingToken = pickTokenFromUrl();
    if (incomingToken) {
      setSsoToken(incomingToken);
    }

    if (!getSsoToken()) {
      redirectToSsoLogin();
      return;
    }

    Get(API.CHECK_LOGIN)
      .then((user) => {
        setAdminInfo(user);
        verifiedInThisPageLoad = true;
        this.setState({ status: "ready" });
      })
      .catch((error) => {
        // 401 已由请求拦截器处理（清登录态并跳认证中心），这里只兜底提示
        clearLoginState();
        this.setState({
          status: "error",
          message: (error && error.msg) || "登录校验未通过，请重新登录"
        });
      });
  };

  render() {
    const { status, message } = this.state;

    if (status === "ready") {
      return this.props.children;
    }

    if (status === "error") {
      return (
        <Result status="warning" title="登录校验未通过" subTitle={message} />
      );
    }

    return (
      <div style={{ textAlign: "center", paddingTop: "30vh" }}>
        <Spin size="large" />
        <div style={{ marginTop: "1em", color: "rgba(0, 0, 0, 0.45)" }}>
          正在校验登录状态...
        </div>
      </div>
    );
  }
}

export default RequireAuth;
